// extracted by mini-css-extract-plugin
export default {"section-about":"About_section-about__2-A6z","container":"About_container__Sl1FZ","subheading":"About_subheading__OVHQ9"};